
import {StorageServiceBase} from "./storage-service-base";
import {ILoggerService} from "../logger/logger.service.interface";

export class SessionStorageService extends StorageServiceBase {
    constructor(logger: ILoggerService) {
        super(sessionStorage, logger);
    }
}